import { interpolateString } from 'support/helpers/strings/interpolateString';

type ParsedError = { title: string; description: string };

export const parseErrorMessage = (errorMessage: unknown): ParsedError => {
  if (typeof errorMessage !== 'string') {
    return { title: '', description: '' };
  }

  const titleRegex = /\[TITLE\s*=\s*([^\]]+)\]/;
  const descriptionRegex = /\[DESCRIPTION\s*=\s*([^\]]+)\]/;

  const titleMatch = errorMessage.match(titleRegex);
  const descriptionMatch = errorMessage.match(descriptionRegex);

  const title = titleMatch ? titleMatch[1].trim() : errorMessage;
  const description = descriptionMatch ? descriptionMatch[1].trim() : errorMessage;

  return { title, description };
};

export const interpolateErrorVariables = (error: ParsedError, variables: Record<string, string>): ParsedError => {
  const { title, description } = error;
  return {
    title: interpolateString(title, variables),
    description: interpolateString(description, variables),
  };
};
